import { ListAlt } from '@mui/icons-material'
import FoodSectionCreate from './FoodSectionCreate'
import FoodSectionEdit from './FoodSectionEdit'
import FoodSectionList from './FoodSectionList'

const foodSectionIndex = {
  icon: ListAlt,
  list: FoodSectionList,
  edit: FoodSectionEdit,
  create: FoodSectionCreate,
}

export default foodSectionIndex
